export const selectAuthenticatedUser =  (state) => state.auth